import React, { useEffect, useState } from "react";
import axiosInstance from "../../api/axiosInstance";
import "./Customers.css";
import { toast } from "react-toastify";

function Customers() {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadCustomers();
  }, []);

  const loadCustomers = async () => {
    try {
      const res = await axiosInstance.get("/accounts/customers/");
      setCustomers(res.data);
    } catch (err) {
      console.error(err);
      toast.error("Failed to load customers");
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="customers-loading">
        <p>Loading customers...</p>
      </div>
    );
  }

  return (
    <div className="customers-container">
      <h2 className="customers-title">Customers</h2>

      <div className="customers-table-wrapper">
        <table className="customers-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Name</th>
              <th>Mobile</th>
              <th>Status</th>
              <th>Joined</th>
            </tr>
          </thead>

          <tbody>
            {customers.map((c, index) => (
              <tr key={c.id}>
                <td>{index + 1}</td>
                <td>{c.name || "—"}</td>
                <td>{c.mobile}</td>

                <td>
                  <span className={c.is_active ? "active" : "inactive"}>
                    {c.is_active ? "Active" : "Inactive"}
                  </span>
                </td>

                <td>
                  {c.date_joined
                    ? new Date(c.date_joined).toLocaleDateString()
                    : "—"}
                </td>
              </tr>
            ))}

            {customers.length === 0 && (
              <tr>
                <td colSpan="5" className="empty">
                  No customers found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Customers;